import { render, staticRenderFns } from "./CreateFormLottery.vue?vue&type=template&id=464ee396"
import script from "./CreateFormLottery.vue?vue&type=script&lang=js"
export * from "./CreateFormLottery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports